import React, { Component } from "react";
export default class ImmediateRecall extends Component {
  render() {
    var {
      immediate_recall_check_1_points,
      immediate_recall_check_2_points,
      immediate_recall_check_3_points,
      immediate_recall_check_4_points,
      immediate_recall_check_5_points,
      immediate_recall_check_6_points,
      immediate_recall_check_7_points,
      immediate_recall_check_8_points,
      immediate_recall_check_9_points,
      immediate_recall_check_10_points,
      immediaterRecallNote,
    } = this.props.data;
    return (
      <div>
        <div style={{ minHeight: 200 }}>
        </div>
      </div>
    );
  }
}
